module.exports = require("!!vue-loader!../node_modules/v-markdown-loader/_cache/vux-loader-37.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/vux-loader.md
// module id = 777
// module chunks = 197